'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _jsx = require('@babel/runtime/helpers/jsx');
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var classNames = require('classnames');
var context = require('@andes/context');
var warning = require('@andes/common/build/utils/warning');
var utils = require('@react-aria/utils');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var focus = require('@react-aria/focus');
var ChevronRight20 = require('@andes/icons/ChevronRight20');
var common = require('@andes/common');
var includes = require('@andes/common/build/utils/includes');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var ChevronRight20__default = /*#__PURE__*/_interopDefaultLegacy(ChevronRight20);
var includes__default = /*#__PURE__*/_interopDefaultLegacy(includes);
const namespace = 'andes-list';
const listGroupNamespace = 'andes-list__group';
const listItemNamespace = 'andes-list__item';
const LIST_DISPLAY_NAME = 'List';
const LIST_GROUP_DISPLAY_NAME = 'ListGroup';
const LIST_ITEM_DISPLAY_NAME = 'ListItem';
const LIST_ITEM_CONTENT_DISPLAY_NAME = 'ListItemContent';
const WARNING_SR_LABEL = '<List> needs some text contents for accessibility reasons. Please add an `srLabel` prop.';
const WARNING_BUTTON_SWITCH_ITEM_SMALL = "A <ListItem> with size=\"small\" does not allow Buttons or Switches as\nrightContent. Please, use a bigger <ListItem> instead";
const WARNING_BUTTON_SIZE = '<ListItem> only supports Buttons with size="medium"';
const WARNING_BADGE_SIZE = '<ListItem> only supports Badges with size="small"';
const WARNING_LIST_ITEM = "<ListItem> needs to be wrapped in a '<List>' for accessibility reasons. \nAdd the '<List>' component.";
const WARNING_LIST_GROUP = "<ListGroup> needs to be wrapped in a '<List>' for accessibility reasons. \nAdd the '<List>' component.";
const ListContext = /*#__PURE__*/React.createContext(false);
function useListContext() {
  return React.useContext(ListContext);
}
function ListProvider(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx__default["default"](ListContext.Provider, {
    value: {}
  }, void 0, children);
}
const _excluded$2 = ["children", "className", "id", "type", "selectable", "withDividers", "component", "srLabel", "aria-label"];
const List = /*#__PURE__*/function () {
  const List = /*#__PURE__*/React.forwardRef((props, ref) => {
    const {
        children,
        className,
        id,
        type = 'default',
        selectable = true,
        withDividers = false,
        component: Component = 'ul',
        srLabel,
        'aria-label': _willdeprecate$ariaLabel
      } = props,
      other = _objectWithoutProperties__default["default"](props, _excluded$2);
    warning__default["default"](srLabel, WARNING_SR_LABEL);
    const componentId = context.useId(id);
    const componentLabel = srLabel || _willdeprecate$ariaLabel;
    const listClassNames = classNames__default["default"](namespace, className, "".concat(namespace, "--").concat(type), {
      ["".concat(namespace, "--selectable")]: selectable,
      ["".concat(namespace, "-with-dividers")]: withDividers
    });
    return /*#__PURE__*/_jsx__default["default"](ListProvider, {}, void 0, /*#__PURE__*/React__default["default"].createElement(Component, _extends__default["default"]({
      className: listClassNames,
      id: componentId,
      ref: ref
    }, other, {
      "aria-label": componentLabel
    }), React__default["default"].Children.map(children, (child, index) => {
      let childNewId;
      if (props.role !== 'listbox') {
        var _child$props;
        const childId = child === null || child === void 0 || (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.id;
        if (childId) {
          childNewId = childId;
        } else if (componentId) {
          childNewId = "".concat(componentId, "-").concat(index);
        }
      }
      return child && /*#__PURE__*/React__default["default"].cloneElement(child, {
        id: childNewId
      });
    })));
  });
  List.displayName = LIST_DISPLAY_NAME;
  return List;
}();
var List$1 = List;
const hasChildNodes = _ref => {
  let {
    label,
    children
  } = _ref;
  return label && React.Children.count(children) > 0;
};
const groupNodeGenerator = function* getCollectionNode(props) {
  const {
    children,
    label,
    'aria-label': ariaLabel
  } = props;
  const rendered = label || children;
  const textValue = (typeof rendered === 'string' ? rendered : '') || ariaLabel || '';
  warning__default["default"](textValue, '<ListGroup> needs some plain text contents for accessibility reasons. Please add a `label` or `aria-label` prop.');
  yield {
    type: 'section',
    props,
    rendered,
    textValue,
    'aria-label': ariaLabel || label,
    hasChildNodes,
    *childNodes() {
      if (label) {
        const items = [];
        React.Children.forEach(children, child => {
          items.push({
            type: 'item',
            element: child
          });
        });
        yield* items;
      }
    }
  };
};
var groupNodeGenerator$1 = groupNodeGenerator;
const SMALL = 'small';
const MEDIUM = 'medium';
const DEFAULT_POSITION_TOP = 'top';
const primarySizes = {
  small: 18,
  medium: 20,
  large: 22
};
const _excluded$1 = ["children", "className", "id", "label", "paddingSize", "size", "component", "itemProps", "headingProps", "groupProps"];
const ListGroup = /*#__PURE__*/function () {
  const ListGroup = props => {
    const {
        children,
        className,
        id,
        label,
        paddingSize,
        size = MEDIUM,
        component: Component = 'ul',
        itemProps,
        headingProps,
        groupProps
      } = props,
      other = _objectWithoutProperties__default["default"](props, _excluded$1);
    const listContext = useListContext();
    const listGroupClassNames = classNames__default["default"](listGroupNamespace, className, "".concat(listGroupNamespace, "--size-").concat(size), {
      ["".concat(listGroupNamespace, "--padding-").concat(paddingSize)]: paddingSize
    });
    React.useEffect(() => {
      warning__default["default"](!!listContext, WARNING_LIST_GROUP);
    }, []);
    return /*#__PURE__*/React__default["default"].createElement("li", _extends__default["default"]({
      className: listGroupClassNames
    }, utils.mergeProps(itemProps, other)), /*#__PURE__*/React__default["default"].createElement("span", _extends__default["default"]({
      className: "".concat(listGroupNamespace, "--header"),
      id: id
    }, headingProps), label), /*#__PURE__*/React__default["default"].createElement(Component, _extends__default["default"]({
      className: "".concat(listGroupNamespace, "--sublist"),
      "aria-labelledby": id
    }, groupProps), React.Children.map(children, (child, index) => {
      var _child$props;
      let childNewId;
      const childId = (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.id;
      if (childId) {
        childNewId = childId;
      } else if (id) {
        childNewId = "".concat(id, "-").concat(index);
      }
      return /*#__PURE__*/React.cloneElement(child, {
        id: childNewId
      });
    })));
  };
  ListGroup.getCollectionNode = groupNodeGenerator$1;
  ListGroup.displayName = LIST_GROUP_DISPLAY_NAME;
  return ListGroup;
}();
var ListGroup$1 = ListGroup;
const getVerifiedRightContent = (rightContent, itemSize) => {
  if ( /*#__PURE__*/React.isValidElement(rightContent)) {
    var _rightContent$type, _rightContent$type2, _rightContent$props2, _rightContent$type3;
    if (((_rightContent$type = rightContent.type) === null || _rightContent$type === void 0 ? void 0 : _rightContent$type.displayName) === 'Button') {
      var _rightContent$props;
      if (itemSize === 'small') {
        warning__default["default"](false, WARNING_BUTTON_SWITCH_ITEM_SMALL);
        return undefined;
      }
      if (((_rightContent$props = rightContent.props) === null || _rightContent$props === void 0 ? void 0 : _rightContent$props.size) !== 'medium') {
        warning__default["default"](false, WARNING_BUTTON_SIZE);
        return /*#__PURE__*/React.cloneElement(rightContent, {
          size: 'medium'
        });
      }
    }
    if (includes__default["default"](['Notification', 'Pill'], (_rightContent$type2 = rightContent.type) === null || _rightContent$type2 === void 0 ? void 0 : _rightContent$type2.displayName) && (rightContent === null || rightContent === void 0 || (_rightContent$props2 = rightContent.props) === null || _rightContent$props2 === void 0 ? void 0 : _rightContent$props2.size) !== 'small') {
      warning__default["default"](false, WARNING_BADGE_SIZE);
      return /*#__PURE__*/React.cloneElement(rightContent, {
        size: 'small'
      });
    }
    if (((_rightContent$type3 = rightContent.type) === null || _rightContent$type3 === void 0 ? void 0 : _rightContent$type3.displayName) === 'Switch' && itemSize === 'small') {
      warning__default["default"](false, WARNING_BUTTON_SWITCH_ITEM_SMALL);
      return undefined;
    }
  }
  return rightContent;
};
var getVerifiedRightContent$1 = getVerifiedRightContent;
var _ChevronRight$1;
const ListItemContent = /*#__PURE__*/function () {
  const ListItemContent = props => {
    var _leftContent$type;
    const {
      children,
      baseList = false,
      title = '',
      description = '',
      rightContent = '',
      leftContent,
      maxLines,
      value,
      size = MEDIUM,
      rightContentPosition = 'top',
      chevron = false,
      id,
      addPrimaryLabel = false
    } = props;
    const isThumbnail = /*#__PURE__*/React.isValidElement(leftContent) && (leftContent === null || leftContent === void 0 || (_leftContent$type = leftContent.type) === null || _leftContent$type === void 0 ? void 0 : _leftContent$type.displayName) === 'Thumbnail';
    const leftContentHasSrc = (leftContent === null || leftContent === void 0 ? void 0 : leftContent.src) && typeof leftContent.src === 'string';
    const hasDescription = description && size !== SMALL;
    const stringRightContent = typeof rightContent === 'string';
    const centerRightContent = leftContentHasSrc || isThumbnail;
    const primaryTextRef = React.useRef(null);
    const [primaryHeight, setPrimaryHeight] = React.useState();
    React.useEffect(() => {
      if (!centerRightContent) {
        var _primaryTextRef$curre;
        setPrimaryHeight((_primaryTextRef$curre = primaryTextRef.current) === null || _primaryTextRef$curre === void 0 ? void 0 : _primaryTextRef$curre.clientHeight);
      }
    }, []);
    const addLabel = addPrimaryLabel;
    const getImageComponent = () => {
      if (leftContentHasSrc) {
        return /*#__PURE__*/React__default["default"].createElement(common.Image, _extends__default["default"]({
          className: "".concat(listItemNamespace, "-image")
        }, leftContent, {
          "aria-hidden": true
        }));
      }
      return leftContent;
    };
    const primaryClassNames = classNames__default["default"]("".concat(listItemNamespace, "-primary"), {
      ["".concat(listItemNamespace, "-primary--max-lines-").concat(maxLines)]: maxLines
    });
    const secondColumnClassNames = classNames__default["default"]("".concat(listItemNamespace, "-second-column"), {
      ["".concat(listItemNamespace, "-second-column-with-centered-text")]: centerRightContent && stringRightContent
    });
    const tertiaryClassNames = classNames__default["default"]("".concat(listItemNamespace, "-tertiary"), "".concat(listItemNamespace, "-tertiary--").concat(centerRightContent ? 'centered' : rightContentPosition));
    const assetClassNames = classNames__default["default"]("".concat(listItemNamespace, "-asset"), {
      ["".concat(listItemNamespace, "-asset--icon")]: !centerRightContent,
      ["".concat(listItemNamespace, "-asset--icon-one-line")]: !hasDescription && primaryHeight && primaryHeight <= primarySizes[size]
    });
    const chevronClassNames = classNames__default["default"]("".concat(listItemNamespace, "-chevron"), "".concat(listItemNamespace, "-chevron--").concat(centerRightContent ? 'centered' : rightContentPosition));
    const getLabelComponent = () => addLabel ? /*#__PURE__*/
    React__default["default"].createElement("label", {
      onClick: event => event.stopPropagation(),
      htmlFor: "".concat(id, "-selection-component-").concat(value),
      className: primaryClassNames,
      ref: primaryTextRef
    }, title) : /*#__PURE__*/React__default["default"].createElement("span", {
      className: primaryClassNames,
      ref: primaryTextRef
    }, title);
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, (title || description) && /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(listItemNamespace, "-first-column")
    }, void 0, leftContent && /*#__PURE__*/_jsx__default["default"]("div", {
      className: assetClassNames,
      "aria-hidden": true
    }, void 0, getImageComponent()), /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(listItemNamespace, "-text")
    }, void 0, title && getLabelComponent(), hasDescription && /*#__PURE__*/_jsx__default["default"]("span", {
      className: "".concat(listItemNamespace, "-secondary")
    }, void 0, description))), !baseList && (rightContent || chevron) && /*#__PURE__*/_jsx__default["default"]("div", {
      className: secondColumnClassNames
    }, void 0, rightContent && /*#__PURE__*/_jsx__default["default"]("span", {
      className: tertiaryClassNames
    }, void 0, getVerifiedRightContent$1(rightContent, size)), chevron && /*#__PURE__*/_jsx__default["default"]("div", {
      className: chevronClassNames,
      "aria-hidden": true
    }, void 0, _ChevronRight$1 || (_ChevronRight$1 = /*#__PURE__*/_jsx__default["default"](ChevronRight20__default["default"], {
      color: "rgba(0, 0, 0, 0.55)",
      "aria-hidden": true
    })))), children);
  };
  ListItemContent.displayName = LIST_ITEM_CONTENT_DISPLAY_NAME;
  return ListItemContent;
}();
var ListItemContent$1 = ListItemContent;
const isRightContentType = value => (value === null || value === void 0 ? void 0 : value.content) !== undefined;
const computeRightContent = _ref => {
  let {
    rightContent: rightContentProp,
    _willdeprecate$tertiary: tertiaryProp,
    rightContentPosition: rightContentPositionProp,
    _willdeprecate$tertiaryPosition: tertiaryPositionProp
  } = _ref;
  if (!rightContentProp && !tertiaryProp) return {
    position: DEFAULT_POSITION_TOP
  };
  const computedRightContentPosition = {
    position: rightContentPositionProp || tertiaryPositionProp || DEFAULT_POSITION_TOP
  };
  if (isRightContentType(rightContentProp)) {
    var _rightContentProp$des;
    return _objectSpread__default["default"](_objectSpread__default["default"]({}, computedRightContentPosition), {}, {
      content: rightContentProp === null || rightContentProp === void 0 ? void 0 : rightContentProp.content,
      description: (_rightContentProp$des = rightContentProp === null || rightContentProp === void 0 ? void 0 : rightContentProp.description) !== null && _rightContentProp$des !== void 0 ? _rightContentProp$des : undefined
    });
  }
  return _objectSpread__default["default"](_objectSpread__default["default"]({}, computedRightContentPosition), {}, {
    content: rightContentProp || tertiaryProp || null,
    position: rightContentPositionProp || tertiaryPositionProp || DEFAULT_POSITION_TOP
  });
};
var computeRightContent$1 = computeRightContent;
const getListItemClassNames = props => {
  var _leftContent$type;
  const {
    className,
    size = MEDIUM,
    selected,
    paddingSize,
    disabled,
    leftContent,
    description
  } = props;
  const isThumbnail = /*#__PURE__*/React.isValidElement(leftContent) && (leftContent === null || leftContent === void 0 || (_leftContent$type = leftContent.type) === null || _leftContent$type === void 0 ? void 0 : _leftContent$type.displayName) === 'Thumbnail';
  const imageHasSrc = (leftContent === null || leftContent === void 0 ? void 0 : leftContent.src) && typeof leftContent.src === 'string';
  const listItemClassNames = classNames__default["default"](listItemNamespace, className, "".concat(listItemNamespace, "--size-").concat(size), {
    ["".concat(listItemNamespace, "--selected-padding-0")]: selected && paddingSize === '0',
    ["".concat(listItemNamespace, "--padding-").concat(paddingSize)]: paddingSize,
    ["".concat(listItemNamespace, "--disabled")]: disabled,
    ["".concat(listItemNamespace, "--selected")]: selected,
    ["".concat(listItemNamespace, "-with-image")]: imageHasSrc || isThumbnail,
    ["".concat(listItemNamespace, "-with-secondary")]: description && size !== 'small'
  });
  return listItemClassNames;
};
var getListItemClassNames$1 = getListItemClassNames;
var _ChevronRight;
const _excluded = ["children", "className", "disabled", "primary", "secondary", "tertiary", "selected", "onClick", "onSelect", "href", "image", "groupIndex", "value", "size", "maxLines", "tertiaryPosition", "chevron", "paddingSize", "id", "target", "component", "title", "description", "rightContent", "leftContent", "rightContentPosition"];
const ListItem = /*#__PURE__*/function () {
  const ListItem = /*#__PURE__*/React.forwardRef((props, ref) => {
    var _computedLeftContent$;
    const {
        children,
        className,
        disabled = false,
        primary: _willdeprecate$primary,
        secondary: _willdeprecate$secondary,
        tertiary: _willdeprecate$tertiary,
        selected = false,
        onClick,
        onSelect,
        href,
        image: _willdeprecate$image,
        groupIndex,
        value,
        size = MEDIUM,
        maxLines,
        tertiaryPosition: _willdeprecate$tertiaryPosition,
        chevron = false,
        paddingSize,
        id,
        target,
        component: Component = 'li',
        title,
        description,
        rightContent,
        leftContent,
        rightContentPosition = 'top'
      } = props,
      other = _objectWithoutProperties__default["default"](props, _excluded);
    const listContext = useListContext();
    const computedTitle = title || _willdeprecate$primary;
    const computedDescription = description || _willdeprecate$secondary;
    const computedRightContent = computeRightContent$1({
      rightContent,
      _willdeprecate$tertiary,
      rightContentPosition,
      _willdeprecate$tertiaryPosition
    });
    const computedLeftContent = leftContent || _willdeprecate$image;
    const isThumbnail = /*#__PURE__*/React.isValidElement(computedLeftContent) && (computedLeftContent === null || computedLeftContent === void 0 || (_computedLeftContent$ = computedLeftContent.type) === null || _computedLeftContent$ === void 0 ? void 0 : _computedLeftContent$.displayName) === 'Thumbnail';
    const leftContentHasSrc = (computedLeftContent === null || computedLeftContent === void 0 ? void 0 : computedLeftContent.src) && typeof computedLeftContent.src === 'string';
    const stringRightContent = typeof (computedRightContent === null || computedRightContent === void 0 ? void 0 : computedRightContent.content) === 'string';
    const centerRightContent = leftContentHasSrc || isThumbnail;
    const {
      focusProps: mainFocusProps,
      isFocusVisible: isMainFocusVisible
    } = focus.useFocusRing({
      within: true
    });
    const {
      focusProps: rightContentFocusProps,
      isFocusVisible: isRightContentFocusVisible
    } = focus.useFocusRing({
      within: true
    });
    const listItemClassNames = getListItemClassNames$1(_objectSpread__default["default"](_objectSpread__default["default"]({}, props), {}, {
      className,
      selected,
      title: computedTitle,
      description: computedDescription,
      rightContent: computedRightContent === null || computedRightContent === void 0 ? void 0 : computedRightContent.content,
      leftContent: computedLeftContent,
      rightContentPosition: computedRightContent === null || computedRightContent === void 0 ? void 0 : computedRightContent.position
    }));
    const itemClassNames = classNames__default["default"](listItemClassNames, {
      ["".concat(listItemNamespace, "--visible-focused")]: isMainFocusVisible && !isRightContentFocusVisible
    });
    const secondColumnClassNames = classNames__default["default"]("".concat(listItemNamespace, "-second-column"), {
      ["".concat(listItemNamespace, "-second-column-with-centered-text")]: centerRightContent && stringRightContent
    });
    const tertiaryContainerClassNames = classNames__default["default"]("".concat(listItemNamespace, "-tertiary-container"), "".concat(listItemNamespace, "-tertiary-container--").concat(centerRightContent ? 'centered' : computedRightContent === null || computedRightContent === void 0 ? void 0 : computedRightContent.position));
    const tertiaryClassNames = classNames__default["default"]("".concat(listItemNamespace, "-tertiary"), "".concat(listItemNamespace, "-tertiary--").concat(centerRightContent ? 'centered' : computedRightContent === null || computedRightContent === void 0 ? void 0 : computedRightContent.position));
    const chevronClassNames = classNames__default["default"]("".concat(listItemNamespace, "-chevron"), "".concat(listItemNamespace, "-chevron--").concat(centerRightContent ? 'centered' : computedRightContent === null || computedRightContent === void 0 ? void 0 : computedRightContent.position));
    const createActionWrapper = () => {
      let ActionWrapper = React.Fragment;
      let actionWrapperProps = {};
      if (href) {
        ActionWrapper = 'a';
        actionWrapperProps = _objectSpread__default["default"](_objectSpread__default["default"]({
          className: "".concat(listItemNamespace, "-anchor"),
          target
        }, disabled ? {
          role: 'link',
          'aria-disabled': true
        } : {
          href
        }), {}, {
          onClick
        });
      } else if (onClick) {
        ActionWrapper = 'button';
        actionWrapperProps = {
          className: "".concat(listItemNamespace, "-action"),
          disabled,
          onClick
        };
      }
      return {
        ActionWrapper,
        actionWrapperProps
      };
    };
    const {
      ActionWrapper,
      actionWrapperProps
    } = createActionWrapper();
    React.useEffect(() => {
      warning__default["default"](!!listContext, WARNING_LIST_ITEM);
    }, []);
    return /*#__PURE__*/React__default["default"].createElement(Component, _extends__default["default"]({
      className: itemClassNames,
      ref: ref,
      id: id
    }, other, mainFocusProps), /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(ActionWrapper, actionWrapperProps, /*#__PURE__*/React__default["default"].createElement(ListItemContent$1, _extends__default["default"]({}, props, {
      baseList: true,
      title: computedTitle,
      description: computedDescription,
      rightContent: computedRightContent === null || computedRightContent === void 0 ? void 0 : computedRightContent.content,
      leftContent: computedLeftContent,
      rightContentPosition: computedRightContent === null || computedRightContent === void 0 ? void 0 : computedRightContent.position
    }))), ((computedRightContent === null || computedRightContent === void 0 ? void 0 : computedRightContent.content) || chevron) && /*#__PURE__*/_jsx__default["default"]("div", {
      className: secondColumnClassNames
    }, void 0, (computedRightContent === null || computedRightContent === void 0 ? void 0 : computedRightContent.content) && /*#__PURE__*/_jsx__default["default"]("div", {
      className: tertiaryContainerClassNames
    }, void 0, /*#__PURE__*/React__default["default"].createElement("span", _extends__default["default"]({
      className: tertiaryClassNames
    }, rightContentFocusProps), getVerifiedRightContent$1(computedRightContent === null || computedRightContent === void 0 ? void 0 : computedRightContent.content, size)), stringRightContent && (computedRightContent === null || computedRightContent === void 0 ? void 0 : computedRightContent.description) && size !== 'small' && /*#__PURE__*/_jsx__default["default"]("span", {
      className: "".concat(listItemNamespace, "-tertiary-description")
    }, void 0, computedRightContent === null || computedRightContent === void 0 ? void 0 : computedRightContent.description)), chevron && /*#__PURE__*/_jsx__default["default"]("div", {
      className: chevronClassNames,
      "aria-hidden": true
    }, void 0, _ChevronRight || (_ChevronRight = /*#__PURE__*/_jsx__default["default"](ChevronRight20__default["default"], {
      color: "rgba(0, 0, 0, 0.55)",
      "aria-hidden": true
    }))))));
  });
  ListItem.displayName = LIST_ITEM_DISPLAY_NAME;
  return ListItem;
}();
var ListItem$1 = ListItem;
exports.List = List$1;
exports.ListGroup = ListGroup$1;
exports.ListItem = ListItem$1;
exports.ListItemContent = ListItemContent$1;
exports["default"] = List$1;
